module.exports = __webpack_public_path__ + "static/media/rect.ad360703.png";